import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent {
  isNoTemplate = false;
  isArabic = false;

  constructor(private route: ActivatedRoute) {
    this.isNoTemplate = this.route.snapshot.queryParamMap.get('error') === 'no-template';
    try {
      this.isArabic = localStorage.getItem('appLanguage') === 'ar';
    } catch {
      this.isArabic = false;
    }
  }
}
